/**
 * Módulo Comunidades.
 * @module Comunidades
 * @see Comunidades
 */

import { useEffect, useState, useRef } from "react";
import {
  get,
  orderByChild,
  equalTo,
  query,
  update,
  set,
  push,
  getDatabase,
  ref as firebaseRef,
} from "firebase/database";
import { TextField } from "@mui/material";
import * as ROUTES from "../../constants/routes";
import { normalizeString } from "../../components/helpers/Various";
import useAuth from "app/hooks/useAuth";
import { useLocation, useNavigate } from "react-router-dom";
import Tooltip from "react-tooltip-lite";
import { useStore } from "react-redux";
import { useFirebase } from "../../../app/firebase/context";
import React from "react";
import Grid from "@mui/material/Grid";
import "font-awesome/css/font-awesome.min.css";
import { ValidatorForm } from "react-material-ui-form-validator";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory, {
  PaginationProvider,
  SizePerPageDropdownStandalone,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import ModalComponent from "app/components/ModalComponent/ModalComponent";
import FormularioEnvioAvisos from "app/components/ModalComponent/FormularioEnvioAvisos";
import BackButton from "app/components/helpers/BackButton";
import { RefreshButton } from "app/components/helpers/Refresh";
import { Dialogo } from "app/components/helpers/Dialogo";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import { ExportToCSV, ExportToPDF } from "app/library/ExportCsvPdf";
import getCustomToastOptions from "app/components/helpers/getCustomToastOptions";
import { toast } from "react-toastify";
import Wizard from "../wizard/Wizard";
import { PiArrowElbowLeftDownBold } from "react-icons/pi";
import { Form } from "react-bootstrap";
import StepContratado from "../wizard/StepContratado";
import ClipLoader from "react-spinners/ClipLoader";
import enviarAvisos, { cargarResultado } from "app/library/enviarAvisos";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getSemaforoComunidad, insertarEnAdminCommunities } from "./FuncionesComunidades";
import { safeReplace } from "app/utils/utils";
import { initializeApp, deleteApp } from "firebase/app";
import { Email } from "@material-ui/icons";
/**
 * Componente principal que muestra la página de gestión de comunidades.
 * Contiene lógica para filtrado, selección, edición, bloqueo y alta de comunidades.
 *
 * @component ComunidadesTabla
 * @returns {JSX.Element} Render del componente de la tabla de comunidades.
 *
 * @description
 * Este componente utiliza múltiples hooks de React para manejar el estado y el ciclo de vida
 * de la tabla de comunidades. También interactúa con el store global para obtener el diccionario
 * de idiomas, así como con la autenticación para identificar al usuario.
 *
 * ### Principales funcionalidades:
 * - Filtrar comunidades por nombre, ID, CIF o dirección.
 * - Alta, baja y bloqueo de comunidades.
 * - Visualización y edición de planes contratados.
 * - Gestión de diálogos y modales.
 *
 * ### Hooks y estados usados:
 * - `useState` para gestionar el estado de la interfaz.
 * - `useRef` para almacenar datos iniciales sin disparar re-renders.
 * - `useStore` para acceder al estado global (diccionario de idioma).
 * - `useAuth` para acceder a la información del usuario autenticado.
 * - `useLocation` para acceder a la ubicación actual del router.
 */

const ComunidadesTabla = () => {
  const currentDate = new Date().toISOString().split("T")[0];
  const [modalOpenDemo, setModalOpenDemo] = useState(false);
  const [esModificar, setEsModificar] = useState(false);
  const store = useStore();
  const lengu = store.getState().lenguajes;
  const diccionario = lengu.diccionario;
  const [filtradosRefresh, setFiltradosRefresh] = useState(); //let [diccionario, setDiccionario] = useState(lengu.diccionario);
  const location = useLocation();
  let [comunidadeslista, setComunidadeslista] = useState([]);
  let [comunidadesSeleccionadas, setComunidadesSeleccionadas] = useState([]);
  let [numRtdos, setNumRtdos] = useState([]);
  const [codigoAlta, setCodigoAlta] = useState("");
  const [datosDespacho, setDatosDespacho] = useState({
    despachoActivado: false,
    comunidadesActivadas: false,
  });
  let [cuerpoBloqueo, setCuerpoBloqueo] = useState("");
  let [tituloBloqueo, setTituloBloqueo] = useState("");
  const datosIniciales = useRef(comunidadeslista);
  const { user } = useAuth();
  const [isModalOpenAlta, setModalOpenAlta] = useState(false);
  const [modalOpenAlta3, setModalOpenAlta3] = useState(false);
  const [step, setStep] = useState(1);
  const listaFiltros = ["Nombre", "Id", "Cif", "Direccion"];
  const [Identificador, setIdentificador] = useState("");
  const [IdentificadorPlan, setIdentificadorPlan] = useState("");
  const [IdComuGratis, setIdComuGratis] = useState("");
  const [loading, setLoading] = useState(false);
  const [datosCompletosSeleccionados, setDatosCompletosSeleccionados] = useState(null);
  const [planHistorico, setPlanHistorico] = useState({
    fechainicio: "",
    plan: "",
    formapago: "",
    iban: "",
    nombre: "",
    vecinos: "",
    tablaPrecios: null,
    precioSelected: null,
    id: "",
  });

  const [dialogRecoverAlta, setDialogRecoverAlta] = useState(false);

  const firebaseConfigAdmin = {
    apiKey: process.env.REACT_APP_API_KEY,
    authDomain: process.env.REACT_APP_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_DATABASE_ADMIN_URL,
    projectId: process.env.REACT_APP_PROJECT_ID,
    storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_APP_ID,
    measurementId: process.env.REACT_APP_MEASUREMENT_ID,
  };

  const [plan, setPlan] = useState({
    plan: "",
    formapago: "",
    iban: "",
    nombre: "",
    vecinos: "",
    tablaPrecios: null,
    precioSelected: null,
    modificar: false,
    cuentaBancaria: "",
  });

  const codigoDemo = "FREE100C365";

  const [modalOpenContratado, setModalOpenContratado] = useState(false);

  const [refrescar, setRefrescar] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [showDialogAlta, setShowDialogAlta] = useState(false);

  const [showDialogForm, setshowDialogForm] = useState(false);
  const [rowDialog, setRowDialog] = useState(null);

  /* objeto que guarda los valores de los inputs */
  const [expanded, setExpanded] = useState(false);

  /* objeto que guarda los valores de los inputs */
  const filterObject = {};

  for (const field of listaFiltros) {
    filterObject[field] = "";
  }

  const estadoInicialFiltros = {
    IdErp: "",
    Id: "",
    Nombre: "",
    Cif: "",
    Poblacion: "",
    Cp: "",
    Vecinos: "",
    Propiedades: "",
    Fecha_Creacion: "",
    Provincia: "",
    Direccion: "",
    Alta: "",
    fechaAlta: "",
    fechaInicio: "",
    fechaFin: "",
  };
  const [filter, setFilter] = useState(estadoInicialFiltros);

  const cabeceraExportacion = [
    diccionario.Alta,
    diccionario.Nombre,
    diccionario.Cif,
    diccionario.Direccion,
    diccionario.Poblacion,
    diccionario.Provincia,
    diccionario.Cp,
    diccionario.Propiedades,
    diccionario.Vecinos,
    diccionario.Fecha_Creacion,
    diccionario.Fecha_Baja,
    diccionario.Bloqueada,
  ];
  const camposExportacion = [
    "Alta",
    "Nombre",
    "Cif",
    "Direccion",
    "Poblacion",
    "Provincia",
    "CP",
    "Propiedades",
    "Vecinos",
    "Fecha_Creacion",
    "Fecha_Baja",
    "bloqueada",
  ];
  const nombreExportacion = "Comunidades" + " " + new Date().toISOString().slice(0, 10);
  const tituloExportacion = "Comunidades";

  const tituloEnvioAvisos = diccionario.tituloFormAvisos;

  const [isModalOpen, setModalOpen] = useState(false);

  /**
   * Retorna un componente visual que indica si una comunidad está activa o no,
   * utilizando íconos y tooltips para brindar más contexto.
   *
   * @function getStatusActiva
   * @param {Object} event - El evento que puede ser utilizado por un handler (actualmente no se usa en la lógica).
   * @param {Object} datosComunidad - Objeto que contiene información de la comunidad, especialmente el estado de "Alta".
   * @param {Object} diccionario - Diccionario de textos para tooltips, debe contener las claves `tip_Baja` y `tip_Alta`.
   * @returns {JSX.Element} Un elemento JSX que muestra un ícono con un tooltip:
   *  - Si la comunidad está activa (datosComunidad.Alta es truthy), muestra un ícono verde de check.
   *  - Si no, muestra un ícono gris de cancelación.
   */
  const getStatusActiva = (event, datosComunidad, diccionario) => {
    const activa = datosComunidad.Alta && datosComunidad.Alta ? datosComunidad.Alta : false;

    return activa ? (
      <Tooltip content={diccionario.tip_Baja}>
        <CheckCircleIcon style={{ color: "green" }} />
      </Tooltip>
    ) : (
      <Tooltip content={diccionario.tip_Alta}>
        <CancelIcon style={{ color: "grey" }} />
      </Tooltip>
    ); /*
    return activa ? (
      <Tooltip content={diccionario.tip_Baja}>
        <img
          src={"/assets/images/iconos/tick24.svg"}
          alt="Icono de alta"
          className="icon-avisos"
        ></img>
      </Tooltip>
    ) : (
      <Tooltip content={diccionario.tip_Alta}>
        <img
          src={"/assets/images/iconos/cross24.svg"}
          alt="Icono de baja"
          className="icon-avisos"
        ></img>{" "}
      </Tooltip>
    );*/
  };

  const getBloqueada = (e, datosComunidad, diccionario) => {
    let bloqueada = false;
    if (datosComunidad.bloqueada && datosComunidad.bloqueada) {
      bloqueada = datosComunidad.bloqueada;
    } /*
    return bloqueada ? (
      <Tooltip content={diccionario.tip_Bloqueada}>
        <LockIcon color="primary" />
      </Tooltip>
    ) : (
      <Tooltip content={diccionario.tip_Bloqueada}>
        <LockOpenIcon color="primary" />
      </Tooltip>
    );*/
    return bloqueada ? (
      <Tooltip content={diccionario.tip_Bloqueada}>
        <img
          src={"/assets/images/iconos/lock.svg"}
          alt="Icono de advertencia"
          className="icon-avisos"
        ></img>
      </Tooltip>
    ) : (
      <Tooltip content={diccionario.tip_Bloqueada}>
        <img
          src={"/assets/images/iconos/unlock.svg"}
          alt="Icono de advertencia"
          className="icon-avisos"
        ></img>
      </Tooltip>
    );
  };

  /**
   * Confirma el bloqueo de una comunidad.
   *
   * @function confirmarBloqueo
   * @description
   * Llama a la función `bloquearComunidad` (presumiblemente una promesa que bloquea la comunidad seleccionada)
   * y, una vez completada, cierra el diálogo de confirmación y alterna el estado de `refrescar`
   * para forzar una recarga de datos en el componente principal.
   *
   * @returns {void}
   */
  const confirmarBloqueo = () => {
    bloquearComunidad().then(() => {
      setShowDialog(false);
      setRefrescar(!refrescar);
    });
  };
  /**
   * Bloquea o desbloquea una comunidad en Firebase, alternando su estado actual.
   *
   * @async
   * @function bloquearComunidad
   * @description
   * Busca una comunidad específica en Firebase Realtime Database usando su `Id`,
   * y actualiza su campo `bloqueada` al valor contrario del actual (`true` -> `false` o viceversa).
   * Luego muestra una notificación de éxito al usuario mediante `toast`.
   *
   * @returns {Promise<void>} Promesa que se resuelve una vez que la comunidad fue actualizada.
   *
   * @throws {Error} Muestra un error por consola si ocurre alguna excepción al acceder o actualizar en Firebase.
   */
  const bloquearComunidad = async () => {
    try {
      const comunidadRef = firebase.getReferencia("Comunidad");
      const idComunidad = rowDialog.Id;

      // Obtener la información actualizada después de bloquear/desbloquear
      const snapshot = await get(query(comunidadRef, orderByChild("Id"), equalTo(idComunidad)));

      const itemId = Object.keys(snapshot.val())[0];

      // Actualizar el estado con la información obtenida
      const updatedData = {
        ...snapshot.val()[itemId],
        bloqueada: !rowDialog.bloqueada,
      };
      const comUpdatear = firebase.getReferencia(`Comunidad/${itemId}`);
      await update(comUpdatear, updatedData);
      toast.success(diccionario.DatosGuardadosCorrectamente, getCustomToastOptions(toast));
    } catch (error) {
      console.error("Error al bloquear/desbloquear comunidad", error);
    }
  };
  /**
   * Abre el diálogo de baja para una comunidad específica.
   *
   * @function abrirDiagoloBaja
   * @param {Event} e - Evento del DOM que se propaga desde un clic u otra acción del usuario.
   * @param {Object} row - Fila seleccionada de la tabla, que representa una comunidad.
   *
   * @description
   * Detiene la propagación del evento para evitar efectos secundarios no deseados (como seleccionar la fila)
   * y luego invoca `obtenerPlan` con el `idInterno` de la comunidad para recuperar su información de plan.
   *
   * @returns {void}
   */
  const abrirDiagoloBaja = (e, row) => {
    e.stopPropagation();
    obtenerPlan(row.idInterno);
  };

  /**
   * Muestra el diálogo de confirmación para dar de baja una comunidad.
   *
   * @function darDeBaja
   * @description
   * Cambia el estado de `showDialogAlta` a `true`, lo que desencadena la apertura del modal o diálogo
   * relacionado con el proceso de baja de una comunidad.
   *
   * @returns {void}
   */
  const darDeBaja = () => {
    setShowDialogAlta(true);
  };
  /**
   * Maneja el clic sobre el estado de "bloqueada" de una comunidad.
   *
   * @function handleBloqueadaClick
   * @param {Event} e - Evento del DOM que se genera al hacer clic.
   * @param {Object} row - Fila de la tabla correspondiente a la comunidad seleccionada.
   *
   * @description
   * Determina si la comunidad está actualmente bloqueada y configura el título y cuerpo
   * del diálogo de confirmación en función de ese estado. Luego abre el diálogo y guarda
   * la fila seleccionada en el estado. También detiene la propagación del evento para evitar
   * que se activen otros manejadores (como la selección de fila).
   *
   * @returns {void}
   */
  const handleBloqueadaClick = (e, row) => {
    const bloqueada = row.bloqueada;
    const titulo = bloqueada ? diccionario.tituloDesBloquear : diccionario.tituloBloquear;
    const cuerpo = bloqueada ? diccionario.cuerpoDesBloquear : diccionario.cuerpoBloquear;
    setCuerpoBloqueo(cuerpo);
    setTituloBloqueo(titulo);
    setShowDialog(true);
    setRowDialog(row);
    e.stopPropagation(); //
  };
  /**
   * Maneja el clic para iniciar el proceso de alta de una comunidad en C365.
   *
   * @function handleAltaC365
   * @param {Event} e - Evento del DOM generado por el clic en la fila.
   * @param {Object} row - Fila de la tabla correspondiente a la comunidad seleccionada.
   *
   * @description
   * Si la comunidad no está dada de alta (`row.Alta !== true`), resetea los valores de
   * `planHistorico` y configura el estado de la interfaz para permitir la creación o
   * edición del plan de la comunidad en un modal de alta. También almacena la información
   * de la comunidad seleccionada en `datosCompletosSeleccionados` y actualiza el estado
   * relacionado con el plan (por ejemplo, vecinos e identificador).
   * Detiene la propagación del evento para evitar que se active otra acción como la selección de la fila.
   *
   * @returns {void}
   */
  const handleAltaC365 = (e, row) => {
    console.log("Iniciando proceso de alta para la comunidad:", row);
    console.log("los muertros del user", user.datosUsuarioBD);

    const currentDate = new Date();
    const fechaContrato = currentDate.toLocaleString("es-ES", {
      year: "2-digit",
      month: "2-digit",
      day: "2-digit",
    });

    const dia = currentDate.getDate();
    const mes = currentDate.toLocaleString("es-ES", { month: "long" });
    const anio = currentDate.getFullYear();

    e.stopPropagation();
    if (row.Alta !== true) {
      setPlanHistorico({
        ...planHistorico,
        plan: "",
        formapago: "",
        iban: "",
      });
      setModalOpenAlta(true);
      setDatosCompletosSeleccionados(row);
      setPlan((prevPlan) => ({
        ...prevPlan,
        vecinos: row.Propiedades,
        idInterno: row.idInterno,
        IBAN: row.IBAN ? row.IBAN : "",
        nombreComunidad: row.Nombre ? row.Nombre : "",
        datosContrato: {
          NombreAdmin: user.datosUsuarioBD
            ? `${user.datosUsuarioBD.Nombre ?? ""} ${user.datosUsuarioBD.Apellido ?? ""} ${
                user.datosUsuarioBD.Apellido2 ?? ""
              }`.trim()
            : "",
          DNIAdmin: user.datosUsuarioBD?.DNI ?? "",
          NombreComunidad: row.Nombre ? row.Nombre : "",
          Ciudad: row.Poblacion ? row.Poblacion : "",
          Provincia: row.Provincia ? row.Provincia : "",
          CodigoPostal: row.Cp ? row.Cp : "",
          Calle: row.Direccion ? row.Direccion : "",
          Email: user.datosUsuarioBD?.Email ?? "",
          Telefono: user.datosUsuarioBD?.Telefono ?? "",
          Dia: dia,
          Mes: mes,
          Anio: anio,
          nombreContrato: `C-${row.idInterno ?? "SinNombre"}-${fechaContrato.replaceAll("/", "-")}`,
        },
        despachoActivado:
          datosDespacho.despachoActivado ?? datosDespacho.despachoActivado ? true : false,
        comunidadesActivadas:
          datosDespacho.comunidadesActivadas ?? datosDespacho.comunidadesActivadas ? true : false,
      }));
      setIdentificador(row.idInterno);
    }
  };
  /**
   * Obtiene el plan de contrato activo de una comunidad desde Firebase.
   *
   * @async
   * @function obtenerPlan
   * @param {string} row - Identificador de la comunidad cuya información de plan se desea obtener.
   *
   * @description
   * Consulta Firebase para obtener los detalles del plan de contrato activo para la comunidad
   * especificada por `row` (ID). Luego, extrae la información relevante (como el IBAN, plan,
   * fecha de inicio, precio, etc.), actualiza el estado del componente con estos datos y abre
   * un modal con la información del plan de la comunidad.
   * También prepara el estado para la posible edición (modificación del plan) y selecciona
   * la comunidad que se está gestionando.
   *
   * @returns {Promise<void>} Promesa que se resuelve una vez que los datos del plan se han cargado
   *    y el estado ha sido actualizado.
   */
  const existeEnOtroDespacho = async (idcomunidad, despachoActual) => {
    const secundariaApp = initializeApp(firebaseConfigAdmin, "secundaria");
    const database = getDatabase(secundariaApp);
    let resultado = false;

    try {
      const dbRef = firebaseRef(database, `communities/${idcomunidad}`);
      const snapshot = await get(dbRef);
      let datos = [];

      const dataComu = snapshot.val();
      if (dataComu.desk && dataComu.desk !== despachoActual) {
        resultado = true;
        console.log("Ya existe la comu en el despacho: " + dataComu.desk);
      }
      return resultado;
    } catch (error) {
      return resultado;
    } finally {
      await deleteApp(secundariaApp);
    }
  };

  const comprobacionComunidadDeBaja = async (idcomunidad, despachoActual) => {
    const secundariaApp = initializeApp(firebaseConfigAdmin, "secundaria");
    const database = getDatabase(secundariaApp);
    let resultado = false;

    try {
      const dbRef = firebaseRef(database, `canceledCommunities/${idcomunidad}`);
      const snapshot = await get(dbRef);
      let datos = [];

      const dataComu = snapshot.val();
      if (dataComu.desk) {
        resultado = dataComu.desk;
        console.log("Ya existe la comu en el despacho: " + dataComu.desk);
      }
      return resultado;
    } catch (error) {
      return resultado;
    } finally {
      await deleteApp(secundariaApp);
    }
  };

  const handleAltaC3653 = async (e, row) => {
    e.stopPropagation();
    const altaEnOtroDespacho = await existeEnOtroDespacho(row.idInterno, user.despacho.Codigo);
    if (altaEnOtroDespacho) {
      toast.error(diccionario.yaExisteEnOtroDespacho, getCustomToastOptions(toast, "error"));
      return;
    }
    setModalOpenAlta3(true);
    console.log("row", row);
  };

  const handleAltaC3652 = async (e, row) => {
    e.stopPropagation();
    const altaEnOtroDespacho = await existeEnOtroDespacho(row.idInterno, user.despacho.Codigo);

    if (altaEnOtroDespacho) {
      toast.error(diccionario.yaExisteEnOtroDespacho, getCustomToastOptions(toast, "error"));
      return;
    }

    setModalOpenDemo(true);
    setIdComuGratis(row.idInterno);
    console.log("row", row);
  };
  const obtenerPlan = async (row) => {
    const snapshot = await get(firebase.getReferencia(`Comunidad/${row}`, null));
    let datetes = snapshot.val().ContratoActivo;
    datetes.IBAN = snapshot.val().IBAN;

    setModalOpenContratado(true);
    setPlanHistorico({
      plan: datetes.plan,
      fechaInicio: datetes.fechaInicio,
      iban: datetes.iban,
      precio: datetes.precioSelected,
      vecinos: datetes.vecinos,
      formapago: datetes.formapago,
      id: row,
      cuentaBancaria: datetes.cuentaBancaria,
    });

    setEsModificar(true);
    const datosComu = snapshot.val();

    /* Lo comento porque no sabemos si usar el campo de vecinos o el de instancias
    let numViviendas = 0;
    if (datosComu.Instancias) {
      numViviendas = datosComu.Instancias.filter((instancia) => instancia.Usuario != "").length;
    }
    datosComu.Vecinos = numViviendas;
    */
    setDatosCompletosSeleccionados(datetes);
    setPlan((prevPlan) => ({
      ...prevPlan,
      vecinos: datosComu.Propiedades,
      idInterno: datosComu.Id,
      modificar: true,
    }));
    setIdentificador(datosComu.Id);
  };
  /**
   * Muestra el modal de modificación de una comunidad en C365.
   *
   * @function handleModificarC365
   * @description
   * Abre el modal para permitir la modificación de los datos de una comunidad en C365.
   * En este caso, simplemente cambia el estado `modalOpenAlta` a `true` para abrir el modal.
   *
   * @returns {void}
   */
  const handleModificarC365 = async () => {
    setModalOpenAlta(true);
  };

  console.log("User", user);
  const avisosBajaAdmin = async (idComunidad) => {
    const titulo = diccionario.avisoBajaAdministradorTitulo;
    const mensaje = diccionario.avisoBajaAdministrador;
    const snapshot = await get(firebase.getReferencia("Usuarios", null));
    let admins = [];
    snapshot.forEach((childSnapshot) => {
      const childData = childSnapshot.val();
      if (childData.Administrador === true) {
        // le pongo en false estas propiedades para que se envie el aviso, en envio avisos filtra por los que no son admins
        childData.Borrado = false;
        childData.Administrador = false;
        admins.push(childData);
      }
    });
    console.log("admins", admins);
    enviarAvisos(
      [idComunidad],
      titulo,
      mensaje,
      "",
      firebase,
      "",
      "",
      "otro",
      [],
      user, // Usuario logeado
      user.despacho, // Despacho
      [],
      false,
      null,
      false,
      admins // Lista de administradores
    )
      .then((res) => {
        console.log("Envío correcto", res);
        setLoading(false);
      })
      .catch((e) => {
        console.log("Envío fallido", e);
        setLoading(false);
      });
  };

  const avisosBajaComunidad = async (idComunidad) => {
    const titulo = diccionario.avisoBajaVecinosTitulo;
    const mensaje = diccionario.avisoBajaVecinos;
    enviarAvisos(
      [idComunidad],
      titulo,
      mensaje,
      "",
      firebase,
      "",
      "",
      "otro",
      [],
      user, // Usuario logeado
      user.despacho, // Despacho
      [],
      false,
      null,
      false
    )
      .then((res) => {
        console.log("Envío correcto", res);
      })
      .catch((e) => {
        console.log("Envío fallido", e);
      });
  };

  /**
   * Maneja el proceso de baja de una comunidad en C365.
   *
   * @async
   * @function handleBajaC365
   * @param {Event} e - Evento del DOM generado por el clic o acción que activa la baja de la comunidad.
   *
   * @description
   * Detiene la propagación del evento y realiza las siguientes acciones:
   * - Cierra los modales abiertos y establece el estado de carga.
   * - Formatea la fecha actual y prepara los datos para actualizar el estado de la comunidad a "baja".
   * - Llama a la función `stopCommunityPayment` para gestionar el proceso de pago en stripe de la comunidad antes de darla de baja.
   * - Actualiza los datos de la comunidad en Firebase, agrega un registro histórico y muestra un mensaje de éxito.
   * - En caso de error, muestra un mensaje de error y establece el estado de carga como `false`.
   *
   * @returns {Promise<void>} Promesa que se resuelve una vez que la baja y los registros históricos se han actualizado.
   */
  const handleBajaC365 = async (e) => {
    e.stopPropagation();
    setModalOpenContratado(false);
    setShowDialogAlta(false);
    setLoading(true);
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleString("es-ES", {
      year: "2-digit",
      month: "2-digit",
      day: "2-digit",
    });

    try {
      const updatedData = {
        Alta: false,
        fechaBaja: formattedDate,
        ContratoActivo: {
          fechaInicio: "",
          fechaFin: "",
          formapago: "",
          iban: "", // MIRAR SI HABRÍA QUE GUARDAR EL IBAN EN EL MOMENTO DE CONTRATAR (SEGURAMENTE SI, Y TENER EN CUENTA )
          plan: "",
          precioSelected: "",
          vecinos: "",
        },
      };
      const datosHistoricos = {
        fechaInicio: planHistorico.fechaInicio,
        fechaFin: formattedDate,
        formapago: planHistorico.formapago,
        iban: planHistorico.iban, // MIRAR SI HABRÍA QUE GUARDAR EL IBAN EN EL MOMENTO DE CONTRATAR (SEGURAMENTE SI, Y TENER EN CUENTA )
        plan: planHistorico.plan,
        precioSelected: planHistorico.precio,
        vecinos: planHistorico.vecinos,
      };

      const comUpdatear11 = firebase.getReferencia(`Comunidad/${planHistorico.id}`);

      const datosHistoricosFirebase = firebase.getReferencia(
        `Comunidad/${planHistorico.id}/HistoricoContratos`
      );

      const functions = getFunctions(firebase.app, process.env.REACT_APP_FIREBASE_ZONE);
      var stopCommunityPayment = httpsCallable(functions, "stopCommunityPayment");
      const deskId = user.despacho.Codigo;

      const comBaja = comunidadeslista.filter((com) => com.idInterno === planHistorico.id);

      const typeIban = comBaja[0].ContratoActivo ? comBaja[0].ContratoActivo.iban : null;

      const type = typeIban === "administrador" ? "Despacho" : "Comunidad";

      stopCommunityPayment({
        deskId: deskId,
        communityId: planHistorico.id,
        type: type,
      })
        .then(async (res) => {
          await update(comUpdatear11, updatedData);
          await push(datosHistoricosFirebase, datosHistoricos);
          // Envío de aviso sobre la baja - FALTA HACER
          //await avisosBajaComunidad(planHistorico.id);

          setShowDialogAlta(false);
          setRefrescar(!refrescar);
          toast.success(diccionario.AltaCorrecta, getCustomToastOptions(toast));
          setLoading(false);
        })
        .catch((e) => {
          // toast.error(diccionario.FalloBajaComunidad, getCustomToastOptions(toast, "error"));
          setLoading(false);
          console.log("Envío fallido", e);
        });

      await update(comUpdatear11, updatedData);
      await push(datosHistoricosFirebase, datosHistoricos);
      await avisosBajaComunidad(planHistorico.id);
      await avisosBajaAdmin(planHistorico.id);

      var removeCommunityFromAdmin = httpsCallable(functions, "removeCommunityFromAdmin");

      const res = await removeCommunityFromAdmin({
        community: planHistorico.id,
      });
      var cancelCommunityFromAdmin = httpsCallable(functions, "cancelCommunityFromAdmin");

      const clon_clon_clon = await cancelCommunityFromAdmin({
        community: planHistorico.id,
        desk: user.despacho.Codigo,
      });
      setShowDialogAlta(false);
      setRefrescar(!refrescar);
      toast.success(diccionario.AltaCorrecta, getCustomToastOptions(toast));
    } catch (error) {
      toast.error(diccionario.FalloBajaComunidad, getCustomToastOptions(toast, "error"));

      console.error("Error al bloquear/desbloquear comunidad", error);
    }
  };

  /**
   * Configuración de las columnas para la tabla de comunidades utilizando la librería `react-bootstrap-table-next`.
   * Esta tabla aprovecha las clases de Bootstrap y las capacidades avanzadas de la librería para ofrecer
   * ordenamiento, formateo de celdas, eventos personalizados y más.
   *
   * @constant {Array} columnas - Array que define las columnas para la tabla de comunidades en `react-bootstrap-table-next`.
   * Cada columna contiene propiedades como texto del encabezado, campos de datos, formateadores, y eventos asociados.
   *
   * @description
   * La constante `columnas` define cómo se estructura la tabla que se visualiza en el componente de React.
   * Usamos `react-bootstrap-table-next` para crear una tabla que permita ordenar las columnas y personalizar
   * la presentación de los datos con formateadores de celdas. Los íconos y valores específicos se integran
   * mediante las funciones `formatter`, y cada columna puede tener un comportamiento asociado a eventos como clics
   * para realizar acciones (ej. bloquear, dar de alta/baja).
   *
   * @see https://react-bootstrap-table.github.io/react-bootstrap-table2/ para más detalles sobre el uso de `react-bootstrap-table-next`.
   */

  const columnas = [
    {
      text: diccionario.estadoComunidad,
      dataField: "Semaforito",
      cellStyle: { textAlign: "center" },
      filtering: false,
      formatter: (e, rowData) => {
        return getSemaforoComunidad(rowData, diccionario);
      },
      headerClasses: "semoforito-header",
    },
    {
      text: diccionario.Altac365,
      dataField: "Alta",
      sort: true,
      /* events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          row.Alta == true ? abrirDiagoloBaja(e, row) : handleAltaC365(e, row);
        },
      },*/
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          row.Alta == true ? abrirDiagoloBaja(e, row) : handleAltaC365(e, row);
        },
      },
      cellStyle: { textAlign: "center" },
      formatter: (e, rowData) => {
        return getStatusActiva(e, rowData, diccionario);
      },
    },
    {
      text: diccionario.idErp,
      dataField: "id_erp",
      sort: true,
      align: "left",
      headerAlign: "left",
    },
    {
      text: diccionario.nombre,
      dataField: "Nombre",
      sort: true,
      align: "left",
      headerAlign: "left",
    },

    { text: diccionario.Cif, dataField: "Cif", sort: true },
    {
      text: diccionario.Direccion,
      dataField: "Direccion",
      sort: true,
      align: "left",
      headerAlign: "left",
    },
    {
      text: diccionario.Poblacion,
      dataField: "Poblacion",
      sort: true,
      align: "left",
      headerAlign: "left",
    },
    {
      text: diccionario.Provincia,
      dataField: "Provincia",
      sort: true,
      align: "left",
      headerAlign: "left",
    },
    { text: diccionario.Cp, dataField: "Cp", sort: true },
    { text: diccionario.Propiedades, dataField: "Propiedades", sort: true },
    { text: diccionario.Vecinos, dataField: "Vecinos", sort: true },
    {
      text: diccionario.Fecha_Creacion,
      dataField: "fechaAlta",
      sort: true,
      align: "center",
    },
    {
      text: diccionario.Fecha_Baja,
      dataField: "fechaBaja",
      sort: true,
      align: "center",
      formatter: (e, rowData) => {
        if (rowData.Alta === true) {
          return "";
        } else {
          return formateoFechaBaja(e, rowData);
        }
      },
    },
    {
      text: diccionario.Bloqueada,
      dataField: "Bloqueada",
      cellStyle: { textAlign: "center" },
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => handleBloqueadaClick(e, row),
      },
      formatter: (e, rowData) => {
        return getBloqueada(e, rowData, diccionario);
      },
    },
  ];
  const tituloTabla = diccionario.listaComunidades;
  const tableLocation = lengu.traduccionTabla;
  const routeDetalle = ROUTES.DETALLE_COMUNIDAD;
  const firebase = useFirebase();

  /**
   * Formatea la fecha de baja de una comunidad y la devuelve en formato "DD/MM/AAAA".
   *
   * @function formateoFechaBaja
   * @param {string} e - El evento de clic (no se utiliza directamente en esta función).
   * @param {Object} rowData - Los datos de la fila actual de la tabla, que contiene la información de la comunidad.
   *
   * @returns {JSX.Element|string} - Si la comunidad no tiene fecha de baja o está activa, devuelve una cadena vacía.
   *                                  Si la comunidad está dada de baja, devuelve la fecha formateada en el formato "DD/MM/AAAA".
   *
   * @description
   * Esta función revisa si la comunidad tiene una fecha de baja definida y si está dada de baja. Si no tiene fecha de baja
   * o está activa, la función retorna una cadena vacía. Si está dada de baja, la fecha de baja es extraída y reestructurada
   * en el formato adecuado (DD/MM/AAAA).
   *
   * La fecha se extrae del campo `fechaBaja` de `rowData`, que se espera que esté en formato "DD/MM/AAAA, HH:MM".
   * Posteriormente, el día, mes y año se separan y se formatean para asegurar que el día y el mes tengan dos dígitos,
   * si es necesario, y luego se devuelve como una cadena o un componente JSX para su renderizado en la tabla.
   */
  const formateoFechaBaja = (e, rowData) => {
    if (!rowData.fechaBaja) {
      return "";
    } else if (rowData.Alta == true) {
      return "";
    } else {
      const fechaGorda = rowData.fechaBaja.split(",");

      const partesFecha = fechaGorda[0].split("/");

      // Obtener el día y el mes
      let dia = partesFecha[0];
      let mes = partesFecha[1];
      const año = partesFecha[2];

      // Asegurarse de que el día y el mes tengan dos dígitos
      dia = dia.padStart(2, "0");
      mes = mes.padStart(2, "0");
      const fechaFormateada = `${dia}/${mes}/${año}`;
      // Formar la nueva fecha en el formato deseado
      return <div>{fechaFormateada}</div>;
    }
  };
  /**
   * Maneja la selección o deselección de todas las filas en la tabla de comunidades.
   *
   * @function handleAllRowSelect
   * @param {boolean} isSelect - Indica si todas las filas han sido seleccionadas (`true`) o deseleccionadas (`false`).
   * @param {Array<Object>} rows - Array de objetos con los datos de todas las filas seleccionadas (no se usa directamente).
   *
   * @returns {void}
   *
   * @description
   * Esta función se ejecuta cuando el usuario selecciona o deselecciona todas las filas desde el checkbox del encabezado
   * en la tabla. Si se seleccionan todas (`isSelect === true`), se filtran únicamente aquellas comunidades que estén de alta
   * (`comunidad.Alta === true`) y se almacenan en el estado `comunidadesSeleccionadas`.
   *
   * Si se deseleccionan todas, el estado `comunidadesSeleccionadas` se limpia completamente.
   */
  const handleAllRowSelect = (isSelect, rows) => {
    if (isSelect) {
      // Filtrar solo las comunidades de alta
      const comunidadesAlta = comunidadeslista.filter((comunidad) => comunidad.Alta);

      setComunidadesSeleccionadas(comunidadesAlta);
    } else {
      setComunidadesSeleccionadas([]);
    }
  };
  /**
   * Maneja la selección o deselección individual de una fila en la tabla de comunidades.
   *
   * @function handleOnSelect
   * @param {Object} row - Objeto que representa la fila seleccionada o deseleccionada.
   * @param {boolean} isSelected - Indica si la fila fue seleccionada (`true`) o deseleccionada (`false`).
   * @param {number} rowIndex - Índice de la fila dentro de la tabla.
   * @param {Event} e - Evento de selección (por ejemplo, clic en checkbox).
   *
   * @returns {void}
   *
   * @description
   * Si una fila es seleccionada, se añade a la lista de `comunidadesSeleccionadas`.
   * Si es deseleccionada, se elimina de esa lista utilizando su `Cif` como identificador único.
   */
  const handleOnSelect = (row, isSelected, rowIndex, e) => {
    if (isSelected) {
      // If the row is selected, add it to the array
      setComunidadesSeleccionadas((prevSelectedRows) => [...prevSelectedRows, row]);
    } else {
      // If the row is deselected, remove it from the array
      setComunidadesSeleccionadas((prevSelectedRows) =>
        prevSelectedRows.filter((selectedRow) => selectedRow.Cif !== row.Cif)
      );
    }
  };
  const navigate = useNavigate();

  /**
   * Opciones de configuración para la paginación de la tabla BootstrapTable.
   *
   * @constant
   * @type {Object}
   * @property {boolean} custom - Habilita la paginación personalizada.
   * @property {number} paginationSize - Número de botones de página visibles.
   * @property {Array<{ text: string, value: number }>} sizePerPageList - Lista de opciones para seleccionar el número de filas por página.
   * @property {number} totalSize - Número total de resultados (necesario para paginación controlada).
   *
   * @example
   * // Usado en combinación con PaginationProvider
   * <PaginationProvider pagination={paginationFactory(options)}>
   *   ...
   * </PaginationProvider>
   */
  let options = {
    custom: true,
    paginationSize: 5,
    sizePerPageList: [
      {
        text: "5",
        value: 5,
      },
      {
        text: "10",
        value: 10,
      },
    ],
    totalSize: numRtdos,
  };
  /**
   * Objeto que define eventos para las filas de la tabla `BootstrapTable`.
   *
   * @constant
   * @type {Object}
   * @property {function(Event, Object, number): void} onClick - Evento que se dispara al hacer clic en una fila.
   *
   * @description
   * Al hacer clic en una fila de la tabla:
   * - Si la comunidad tiene `Alta === true`, se navega a la página de detalle usando `navigate()`.
   * - Si no está de alta, se muestra un toast informativo indicando que la comunidad no está activa.
   */
  const tableRowEvents = {
    onClick: (e, row, rowIndex) => {
      row.modalAltaC365 = false;

      if (row.Alta === true) {
        navigate(routeDetalle + "/" + row.idInterno, { state: { ...row } });
      } else {
        toast.info(diccionario.ComunidadNoAlta, getCustomToastOptions(toast, "info"));
      }
    },
  };
  /**
   * Carga la lista de comunidades desde Firebase y actualiza el estado del componente.
   *
   * - Si el usuario no es SuperAdmin, filtra las comunidades a las que tiene acceso.
   * - Excluye comunidades marcadas como "Borrado".
   * - Calcula el número de vecinos por comunidad basado en sus instancias.
   * - Asigna el IBAN del despacho a cada comunidad.
   *
   * Actualiza los siguientes estados:
   * - `comunidadeslista`: con las comunidades activas y accesibles.
   * - `numRtdos`: con el número total de resultados cargados.
   * - `datosIniciales`: con la referencia inicial de los datos para futuros filtros o reseteos.
   * - `loading`: indica el estado de carga durante la operación.
   *
   * @async
   * @function cargarComunidades
   * @returns {Promise<void>}
   */
  const cargarComunidades = async () => {
    let comunidades = [];
    if (!user.SuperAdmin) {
      const snapshot5 = await get(
        firebase.getReferencia(`Usuarios/${firebase.auth.currentUser.uid}`, null)
      );

      snapshot5.val().Comunidades &&
        Object.keys(snapshot5.val().Comunidades).forEach((comunidad) => {
          if (comunidad !== "desk") {
            comunidades.push(comunidad);
          }
        });
    }

    setLoading(true);
    try {
      const snapshot2 = await get(firebase.getReferencia("Despacho", null));
      let ibanDespacho = snapshot2.val().Iban ? snapshot2.val().Iban : "";
      const snapshot = await get(firebase.getReferencia("Comunidad", null));
      let datos = [];
      snapshot.forEach((childSnapshot) => {
        const childKey = childSnapshot.key;
        const childData = childSnapshot.val();
        childData.idInterno = childKey;
        childData.id_erp = childData.id_erp ? parseInt(childData.id_erp) : "";
        if (!childData.Borrado) {
          let numViviendas = 0;
          if (childData.Instancias) {
            numViviendas = childData.Instancias.filter(
              (instancia) => instancia.Usuario != ""
            ).length;
          }
          childData.ibanDespacho = ibanDespacho;
          childData.Vecinos = numViviendas;
          if (comunidades.includes(childKey) || comunidades.length === 0) {
            datos.push(childData);
          }
        }
      });

      setComunidadeslista(datos);
      setNumRtdos(datos.length);
      datosIniciales.current = datos;
    } catch (error) {
      console.error("Error al cargar comunidades", error);
    }
    setLoading(false);
  };
  /**
   * useEffect que gestiona la carga inicial de comunidades.
   *
   * - Si `location.state` existe (por ejemplo, tras navegar desde otra página con datos),
   *   utiliza la lista de comunidades ya obtenida para evitar una nueva carga desde Firebase.
   * - Si no hay `location.state`, invoca `cargarComunidades` para obtener los datos directamente desde Firebase.
   *
   * Se ejecuta cada vez que cambia `refrescar`, lo que permite volver a cargar los datos
   * desde Firebase cuando se actualizan desde otras acciones (por ejemplo, al bloquear o dar de baja una comunidad).
   *
   * @effect
   * @dependency [refrescar]
   */
  useEffect(async () => {
    const obtenerDatosDelDelDespacho = async () => {
      const snapshot = await get(firebase.getReferencia(`Despacho`, null));
      const { despachoActivado, comunidadesActivadas } = snapshot.val();
      return { despachoActivado, comunidadesActivadas };
    };
    const datosDespacho = await obtenerDatosDelDelDespacho();
    setDatosDespacho(datosDespacho);
    if (location.state) {
      const loc = location.state;
      setComunidadeslista(loc.listaComus);
      setNumRtdos(loc.listaComus.length);
      datosIniciales.current = loc.listaComus;
    } else {
      cargarComunidades();
    }
  }, [refrescar]);
  /**
   * Maneja el evento de tecla presionada en el input de búsqueda.
   * Si se presiona "Enter", previene el comportamiento por defecto
   * (como enviar el formulario) y ejecuta la función de filtrado.
   *
   * @param {React.KeyboardEvent} e - Evento de teclado disparado en el input.
   */
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleFiltrarClick(e);
    }
  };
  /**
   * Carga todas las comunidades desde Firebase, aplica los filtros introducidos por el usuario
   * y actualiza el listado visible con las coincidencias.
   *
   * @param {React.SyntheticEvent} [e] - Evento del formulario (opcional).
   */
  const handleFiltrarClick = async (e) => {
    let datos = [];
    try {
      const snapshot = await get(firebase.getReferencia("Comunidad", null));

      snapshot.forEach((childSnapshot) => {
        const childKey = childSnapshot.key;
        const childData = childSnapshot.val();
        childData.idInterno = childKey;
        if (!childData.Borrado) {
          let numViviendas = 0;
          if (childData.Instancias) {
            numViviendas = childData.Instancias.filter(
              (instancia) => instancia.Usuario != ""
            ).length;
          }
          childData.Vecinos = numViviendas;
          datos.push(childData);
        }
      });
    } catch (error) {
      console.error("Error al cargar comunidades", error);
    }

    e && e.preventDefault();

    try {
      //if (comunidadeslista.length > 0) {
      let filtrados = [];
      if (
        !(
          filter.IdErp === "" &&
          filter.Id === "" &&
          filter.Nombre === "" &&
          filter.Cif === "" &&
          filter.Poblacion === "" &&
          filter.Cp === "" &&
          filter.Vecinos === "" &&
          filter.Propiedades === "" &&
          filter.Fecha_Creacion === "" &&
          filter.Provincia === "" &&
          filter.Direccion === "" &&
          filter.Alta !== true &&
          filter.fechaInicio === "" &&
          filter.fechaFin === ""
        )
      ) {
        filtrados = datos.filter(
          (comunidad) =>
            (filter.IdErp === "" ||
              (comunidad.id_erp &&
                normalizeString(comunidad.id_erp.toLowerCase()).includes(
                  normalizeString(filter.IdErp.toLowerCase())
                ))) &&
            (filter.Id === "" ||
              (comunidad.Id &&
                normalizeString(comunidad.Id.toLowerCase()).includes(
                  normalizeString(filter.Id.toLowerCase())
                ))) &&
            (filter.Nombre === "" ||
              (comunidad.Nombre &&
                normalizeString(comunidad.Nombre.toLowerCase()).includes(
                  normalizeString(filter.Nombre.toLowerCase())
                ))) &&
            (filter.Cif === "" ||
              (comunidad.Cif &&
                normalizeString(comunidad.Cif.toLowerCase()).includes(
                  normalizeString(filter.Cif.toLowerCase())
                ))) &&
            (filter.Poblacion === "" ||
              (comunidad.Poblacion &&
                normalizeString(comunidad.Poblacion.toLowerCase()).includes(
                  normalizeString(filter.Poblacion.toLowerCase())
                ))) &&
            (filter.Cp === "" ||
              (comunidad.Cp && comunidad.Cp.toString().includes(filter.Cp.toString()))) &&
            (filter.Propiedades === "" ||
              (comunidad.Propiedades &&
                comunidad.Propiedades.toString().includes(filter.Propiedades))) &&
            (filter.Vecinos === "" ||
              (comunidad.Vecinos && comunidad.Vecinos.toString().includes(filter.Vecinos))) &&
            (filter.Fecha_Creacion === "" ||
              (comunidad.Fecha_Creacion &&
                normalizeString(comunidad.Fecha_Creacion.toLowerCase()).includes(
                  normalizeString(filter.Fecha_Creacion.toLowerCase())
                ))) &&
            (filter.Provincia === "" ||
              (comunidad.Provincia && compareWords(filter.Provincia, comunidad.Provincia))) &&
            (filter.Direccion === "" ||
              (comunidad.Direccion &&
                normalizeString(comunidad.Direccion.toLowerCase()).includes(
                  normalizeString(filter.Direccion.toLowerCase())
                ))) &&
            (filter.fechaInicio === "" ||
              (comunidad.fechaAlta &&
                compareDates(comunidad.fechaAlta, filter.fechaInicio) >= 0)) &&
            (filter.fechaFin === "" ||
              (comunidad.fechaAlta && compareDates(comunidad.fechaAlta, filter.fechaFin) <= 0))
        );
      } else {
        filtrados = datos;
      }

      setNumRtdos(filtrados.length);
      setComunidadeslista(filtrados);
      //}
    } catch (error) {
      console.log(error);
    }
  };

  const handleKeyPress2 = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      //altaGratis(e);
      comprobarComuBaja();
    }
  };
  /**
   * Compara dos cadenas de texto permitiendo coincidencias parciales y sin importar el orden,
   * mayúsculas/minúsculas o caracteres especiales.
   *
   * @param {string} searchTerm - Término de búsqueda introducido por el usuario.
   * @param {string} actualValue - Valor real a comparar contra el término de búsqueda.
   * @returns {boolean} `true` si todos los términos de búsqueda están parcialmente contenidos en el valor real, `false` en caso contrario.
   */
  function compareWords(searchTerm, actualValue) {
    // Function to normalize the string by removing special characters
    function normalizeAndCleanString(str) {
      return normalizeString(str.toLowerCase())
        .replace(/[^\w\s]/g, "") // Removes special characters
        .split(" ")
        .filter((word) => word) // Removes empty strings from spaces
        .sort(); // Sort words to handle any order
    }

    // Normalize and clean both the search term and actual value
    const searchWords = normalizeAndCleanString(searchTerm);
    const actualWords = normalizeAndCleanString(actualValue);

    // Check if every word in searchWords partially matches any word in actualWords
    return searchWords.every((searchWord) =>
      actualWords.some((actualWord) => actualWord.includes(searchWord))
    );
  }
  /**
   * Obtiene los CIF de las comunidades que están de baja (no activas).
   *
   * @returns {string[]} Un array con los CIF de las comunidades de baja. Si no hay comunidades o ninguna de ellas está de baja, retorna un array vacío.
   */
  const obtenerCIFComunidadesDeBaja = () => {
    if (!comunidadeslista) return [];
    // Filtrar solo las comunidades de baja
    const comunidadesDeBaja =
      comunidadeslista && comunidadeslista.filter((comunidad) => !comunidad.Alta);

    // Obtener solo los CIF de las comunidades de baja
    const cifComunidadesDeBaja =
      comunidadesDeBaja && comunidadesDeBaja.map((comunidad) => comunidad.Cif);

    return cifComunidadesDeBaja;
  };
  /**
   * Resetea los valores de los filtros y vuelve a mostrar todas las comunidades.
   *
   * Esta función restablece el estado de los filtros a su valor inicial y
   * vuelve a cargar la lista completa de comunidades sin aplicar ningún filtro.
   *
   * @returns {void}
   */
  const resetObject = () => {
    setFilter(estadoInicialFiltros);
    setComunidadeslista(datosIniciales.current);
  };

  /**
   * Expande o contrae el buscador.
   *
   * Esta función alterna el estado de expansión del buscador. Si el buscador está
   * expandido, se contrae, y si está contraído, se expande.
   *
   * @returns {void}
   */
  const toggleExpansion = () => {
    setExpanded(!expanded);
  };

  /**
   * Formatea una fecha en formato "DD/MM/AA" a partir de una fecha en formato "YYYY-MM-DD".
   *
   * La función toma una fecha en formato "YYYY-MM-DD" y la convierte en una cadena de texto
   * con el formato "DD/MM/AA", donde "DD" es el día, "MM" el mes y "AA" los últimos dos dígitos del año.
   *
   * @param {string} fecha - La fecha en formato "YYYY-MM-DD" que se desea formatear.
   * @returns {string} La fecha formateada en formato "DD/MM/AA". Si la fecha de entrada está vacía,
   *                   se devuelve la fecha tal como está.
   */
  function formatFecha(fecha) {
    if (fecha != "") {
      var components = fecha.split("-");
      var year = components[0].slice(-2); // Obtener los últimos dos dígitos del año
      var month = components[1];
      var day = components[2];

      // Formatear la fecha
      var formattedDate = day + "/" + month + "/" + year;
      return formattedDate;
    }
    return fecha;
  }

  /**
   * Compara dos fechas en diferentes formatos.
   *
   * @param {string} date1 - Primera fecha en formato "DD/MM/YY" o "DD/MM/YYYY"
   * @param {string} date2 - Segunda fecha en formato "YYYY-MM-DD"
   * @returns {number} - Retorna -1 si date1 < date2, 0 si son iguales, 1 si date1 > date2
   */
  function compareDates(date1, date2) {
    if (!date1 || !date2) return 0;

    // Convertir date1 de "DD/MM/YY" o "DD/MM/YYYY" a objeto Date
    let parts1 = date1.split("/");
    let day1 = parseInt(parts1[0], 10);
    let month1 = parseInt(parts1[1], 10) - 1; // Los meses en JavaScript son 0-indexados
    let year1 = parseInt(parts1[2], 10);

    // Si el año tiene 2 dígitos, asumimos que es 20XX
    if (year1 < 100) {
      year1 += 2000;
    }

    let dateObj1 = new Date(year1, month1, day1);

    // Convertir date2 de "YYYY-MM-DD" a objeto Date
    let parts2 = date2.split("-");
    let year2 = parseInt(parts2[0], 10);
    let month2 = parseInt(parts2[1], 10) - 1;
    let day2 = parseInt(parts2[2], 10);

    let dateObj2 = new Date(year2, month2, day2);

    // Comparar las fechas
    if (dateObj1 < dateObj2) return -1;
    if (dateObj1 > dateObj2) return 1;
    return 0;
  }

  /**
   * Maneja los cambios en los campos del formulario y actualiza el estado del filtro.
   *
   * Esta función se utiliza para capturar el valor de los inputs del formulario y actualizar el estado
   * de `filter` con el nuevo valor, manteniendo los valores anteriores sin cambios.
   *
   * @param {Object} e - El evento de cambio del input.
   * @param {string} e.target.name - El nombre del campo que fue modificado.
   * @param {string} e.target.value - El nuevo valor del campo que fue modificado.
   */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilter((prevFormulario) => ({
      ...prevFormulario,
      [name]: value,
    }));
  };
  /**
   * Función que abre el modal de envío.
   *
   */
  const modalEnvio = () => {
    setModalOpen(true);
  };
  /**
   * Función que abre el modal Diagolo.
   *
   */
  const abrirDiagolo = () => {
    setshowDialogForm(true);
  };
  /**
   * Función que resetea el plan contratado
   *
   */
  const resetFormContrato = () => {
    setPlan({
      plan: "",
      formapago: "",
      iban: "",
      nombre: Identificador,
      vecinos: "",
      tablaPrecios: null,
      precioSelected: null,
    });
  };

  const migrarBaseDeDatos = async (idcomunidad, originDesk) => {
    // Quitar esta morralla
    try {
      if (originDesk) {
        const destinyDesk = user.despacho.Codigo; // El destino es el despacho actual

        const functions = getFunctions(firebase.app, process.env.REACT_APP_FIREBASE_ZONE);
        var migrateCommunityDatabase = httpsCallable(functions, "migrateCommunityDatabase");
        var migrateCommunityDocuments = httpsCallable(functions, "migrateCommunityDocuments");

        const resData = await migrateCommunityDatabase({
          community: idcomunidad,
          originDesk: originDesk,
          destinyDesk: destinyDesk,
        });

        const resDocuments = await migrateCommunityDocuments({
          community: idcomunidad,
          originDesk: originDesk,
          destinyDesk: destinyDesk,
        });
      }
    } catch (error) {
      console.log("Error del diablo", error);
    }
  };

  const comprobarComuBaja = async (comunidad) => {
    // 7777
    const codDeskOrigen = await comprobacionComunidadDeBaja(
      IdComuGratis,
      firebaseConfigAdmin,
      firebase
    );
    if (codDeskOrigen) {
      setDialogRecoverAlta(true);
    } else {
      altaGratis();
    }
  };

  const altaGratis = async (recuperarDatos = false) => {
    setLoading(true);
    const codDeskOrigen = await comprobacionComunidadDeBaja(
      IdComuGratis,
      firebaseConfigAdmin,
      firebase
    );

    // De momento hago el proceso siempre, luego habrá que tener en cuenta la decisión del usuario
    if (codDeskOrigen && recuperarDatos) {
      await migrarBaseDeDatos(IdComuGratis, codDeskOrigen);
      console.log("estvo de baja");
    }

    if (codigoAlta.toUpperCase() === codigoDemo) {
      const currentDate = new Date();
      const formattedDateAlta = currentDate.toLocaleString("es-ES", {
        year: "2-digit",
        month: "2-digit",
        day: "2-digit",
      });
      const formattedDate = currentDate.toLocaleString("es-ES", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
      const updatedData = {
        Alta: true,
        fechaAlta: formattedDateAlta,
        ContratoActivo: {
          fechaInicio: formattedDate,
          fechaFin: null,
          formapago: "0",
          iban: "PERIODO DE PRUEBA", // MIRAR SI HABRÍA QUE GUARDAR EL IBAN EN EL MOMENTO DE CONTRATAR (SEGURAMENTE SI, Y TENER EN CUENTA )
          plan: "total",
          precioSelected: "0",
          vecinos: plan.vecinos,
          cuentaBancaria: "PERIODO DE PRUEBA",
        },
      };

      const comUpdatear = firebase.getReferencia(`Comunidad/${IdComuGratis}`);
      await update(comUpdatear, updatedData);
      setComunidadeslista((prevComunidades) =>
        prevComunidades.map((comunidad) => {
          if (comunidad.idInterno === IdComuGratis) {
            return { ...comunidad, Alta: true };
          }
          return comunidad;
        })
      );
      await insertarEnAdminCommunities(
        IdComuGratis,
        user.despacho.Codigo,
        firebaseConfigAdmin,
        firebase
      );
      setCodigoAlta("");
      setModalOpenDemo(false);
      setIdComuGratis("");
      setDialogRecoverAlta(false);
      toast.success(diccionario.AltaCorrectaDemo, getCustomToastOptions(toast));
      setLoading(false);
    } else {
      setLoading(false);
      toast.error(diccionario.CodigoIncorrectoDemo, getCustomToastOptions(toast, "error"));
    }
    console.log("alta gratis", codigoAlta);
    console.log("codigo", codigoDemo);
  };
  if (loading) {
    return (
      <div>
        <ClipLoader
          size={100}
          color={"#123abc"}
          loading={loading}
          cssOverride={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
          speedMultiplier={1}
        />
      </div>
    );
  }
  return (
    <div className="contenedor-comunidades">
      <Dialogo
        showDialog={showDialog}
        diagoloBody={cuerpoBloqueo}
        diagoloTitulo={tituloBloqueo}
        onConfirm={confirmarBloqueo}
        onClose={() => setShowDialog(false)}
      />

      <Dialogo
        recuperarDatos={true}
        showDialog={dialogRecoverAlta}
        diagoloBody={
          diccionario["detectedComu"] ||
          "Esta comunidad ya estuvo de alta en c365, ¿quieres recuperar todos los datos de esa comunidad?"
        }
        diagoloTitulo={diccionario["RecoverOldData"] || "Recuperar todos los datos"}
        onConfirm={() => altaGratis(true)}
        onClose={() => {
          setDialogRecoverAlta(false);
          altaGratis();
        }}
      />
      <Dialogo
        showDialog={showDialogAlta}
        diagoloBody={safeReplace(diccionario.ConfirmarBajaComunidad, "${var1}", Identificador)}
        diagoloTitulo={"Dar de baja comunidad de C365"}
        onConfirm={handleBajaC365}
        onClose={() => setShowDialogAlta(false)}
      />

      <div className={`expansible-container ${expanded ? "expanded" : "contracted"}`}>
        <div className="header" onClick={toggleExpansion}>
          <p style={{ fontWeight: "500" }}>{diccionario.Buscador}</p>
          {expanded ? (
            <i className="fa fa-chevron-up" aria-hidden="true"></i>
          ) : (
            <i className="fa fa-chevron-down" aria-hidden="true"></i>
          )}
        </div>
        <div className="container-formulario">
          <ValidatorForm onSubmit={handleFiltrarClick}>
            <Grid container spacing={3}>
              <Grid className="Buscador" item lg={1} md={1} sm={1} xs={1} sx={{ mt: 0 }}>
                <p>
                  <label>{diccionario.idErp}</label>
                </p>
                <TextField
                  value={filter.IdErp}
                  name="IdErp"
                  onChange={handleChange}
                  onKeyDown={handleKeyPress}
                />
              </Grid>

              <Grid className="Buscador" item lg={2} md={3} sm={3} xs={3} sx={{ mt: 0 }}>
                <p>
                  <label>{diccionario.Nombre}</label>
                </p>
                <TextField
                  value={filter.Nombre}
                  name="Nombre"
                  onChange={handleChange}
                  onKeyDown={handleKeyPress}
                />
              </Grid>

              <Grid className="Buscador" item lg={3} md={4} sm={4} xs={4} sx={{ mt: 0 }}>
                <p>
                  <label>{diccionario.Direccion}</label>
                </p>
                <TextField
                  value={filter.Direccion}
                  name="Direccion"
                  onChange={handleChange}
                  onKeyDown={handleKeyPress}
                />
              </Grid>

              <Grid className="Buscador" item lg={4} md={4} sm={4} xs={4} sx={{ mt: 0 }}>
                <p>
                  <label>{diccionario.CIF}</label>
                </p>
                <TextField
                  value={filter.Cif}
                  name="Cif"
                  onChange={handleChange}
                  onKeyDown={handleKeyPress}
                />
              </Grid>

              <Grid className="Buscador" item lg={2} md={4} sm={4} xs={4} sx={{ mt: 0 }}>
                <p>
                  <label>{diccionario.Provincia}</label>
                </p>
                <TextField
                  value={filter.Provincia}
                  name="Provincia"
                  onChange={handleChange}
                  onKeyDown={handleKeyPress}
                />
              </Grid>

              <Grid className="Buscador" item lg={2} md={4} sm={4} xs={4} sx={{ mt: 0 }}>
                <p>
                  <label>{diccionario.Poblacion}</label>
                </p>
                <TextField
                  value={filter.Poblacion}
                  name="Poblacion"
                  onChange={handleChange}
                  onKeyDown={handleKeyPress}
                />
              </Grid>

              <Grid className="Buscador" item lg={2} md={4} sm={4} xs={4} sx={{ mt: 0 }}>
                <p>
                  <label>{diccionario.Cp}</label>
                </p>
                <TextField
                  value={filter.Cp}
                  name="Cp"
                  onChange={handleChange}
                  onKeyDown={handleKeyPress}
                />
              </Grid>
              <Grid className="Buscador" item lg={1} md={1} sm={1} xs={1} sx={{ mt: 0 }}>
                <p>
                  <label>{diccionario.Propiedades}</label>
                </p>
                <TextField
                  value={filter.Propiedades}
                  name="Propiedades"
                  onChange={handleChange}
                  onKeyDown={handleKeyPress}
                />
              </Grid>
              <Grid className="Buscador" item lg={1} md={1} sm={1} xs={1} sx={{ mt: 0 }}>
                <p>
                  <label>{diccionario.Vecinos}</label>
                </p>
                <TextField
                  value={filter.Vecinos}
                  name="Vecinos"
                  onChange={handleChange}
                  onKeyDown={handleKeyPress}
                />
              </Grid>

              <Grid className="Buscador" item lg={2} md={2} sm={2} xs={2} sx={{ mt: 0 }}>
                <Form.Group controlId="fechaInicio">
                  <Form.Label>{diccionario.AltaDesde}</Form.Label>
                  <Form.Control
                    name="fechaInicio"
                    type="date"
                    value={filter.fechaInicio}
                    onChange={handleChange}
                    onKeyDown={handleKeyPress}
                  />
                </Form.Group>
              </Grid>

              <Grid className="Buscador" item lg={2} md={2} sm={2} xs={2} sx={{ mt: 0 }}>
                <Form.Group controlId="fechaFin">
                  <Form.Label>{diccionario.AltaHasta}</Form.Label>
                  <Form.Control
                    name="fechaFin"
                    type="date"
                    value={filter.fechaFin}
                    onChange={handleChange}
                    onKeyDown={handleKeyPress}
                  />
                </Form.Group>
              </Grid>
              <Grid
                className="boton-gordo"
                item
                lg={2}
                md={2}
                sm={2}
                xs={2}
                sx={{ mt: 0 }}
                style={{ marginTop: "0px" }}
              >
                <button
                  onClick={resetObject}
                  type="reset "
                  className="btn btn-outline-secondary mr-2 mt-3 px-4"
                  id="restaurar"
                >
                  {diccionario.Restaurar}
                </button>
                <button type="submit" className="btn btn-outline-primary mt-3 px-4">
                  {diccionario.Buscar}
                </button>
              </Grid>
            </Grid>
          </ValidatorForm>
        </div>
      </div>

      <div className="container-tabla" style={{ height: "auto", width: "auto" }}>
        <PaginationProvider pagination={paginationFactory(options)}>
          {({ paginationProps, paginationTableProps }) => {
            const { page, sizePerPage, totalSize } = paginationProps;
            const startResult = (page - 1) * sizePerPage + 1;
            const endResult = Math.min(page * sizePerPage, totalSize);
            return (
              <div>
                <div className="toolbar-tabla-comunidades">
                  <div className="contenido-botones-comunidades">
                    <button
                      className="btn btn-outline-primary mx-2"
                      onClick={() =>
                        ExportToPDF(
                          comunidadeslista,
                          cabeceraExportacion,
                          camposExportacion,
                          nombreExportacion,
                          tituloExportacion
                        )
                      }
                    >
                      {diccionario.exportarPdf}
                    </button>
                    {ExportToCSV(
                      comunidadeslista,
                      cabeceraExportacion,
                      camposExportacion,
                      nombreExportacion,
                      tituloExportacion,
                      diccionario
                    )}

                    <RefreshButton onRefresh={handleFiltrarClick} />
                    <Tooltip content={diccionario.tip_EnvioComunidades}>
                      <span>
                        <button
                          onClick={() => modalEnvio()}
                          variant="outlined"
                          disabled={!comunidadesSeleccionadas.length > 0}
                          size="large"
                          color="primary"
                          className="btn btn-outline-primary mt-3 px-4"
                        >
                          {diccionario.ENVIAR_AVISO}
                        </button>
                      </span>
                    </Tooltip>
                    <BackButton />
                    <div className="pagination-container" style={{ display: "flex" }}>
                      <p>{diccionario.filasPagina} &nbsp;</p>
                      <SizePerPageDropdownStandalone {...paginationProps} />
                    </div>
                  </div>
                  <div className="toolbar-envio-avisos">
                    <div className="comunidades-seleccionadas">
                      <div className="flechita">
                        <PiArrowElbowLeftDownBold />
                      </div>
                      <h5 style={{ marginTop: "5px", marginLeft: "5px" }}>
                        {comunidadesSeleccionadas.length === 0
                          ? ` ${diccionario.MarcarEnviarAviso}`
                          : `${diccionario.HasSeleccionado}${
                              comunidadesSeleccionadas.length === 1
                                ? ` 1 ${diccionario.comunidad}`
                                : ` ${comunidadesSeleccionadas.length} ${diccionario.comunidades}`
                            } ${diccionario.paraAviso}.`}
                      </h5>
                    </div>
                  </div>
                </div>
                <BootstrapTable
                  keyField="Cif"
                  data={comunidadeslista}
                  columns={columnas}
                  {...paginationTableProps}
                  rowEvents={tableRowEvents}
                  selectRow={{
                    mode: "checkbox",
                    clickToSelect: true,
                    nonSelectable: obtenerCIFComunidadesDeBaja(),
                    bgColor: "rgba(44, 169, 220, 0.1)",
                    onSelect: handleOnSelect,
                    onSelectAll: handleAllRowSelect,
                    selected: comunidadesSeleccionadas.map((comunidad) => comunidad.Cif),
                  }}
                />
                <div className="pagination-container-footer">
                  {totalSize > 0 ? (
                    <div className="data-info" style={{ fontWeight: "bold" }}>
                      {diccionario.Mostrando} {startResult} {diccionario.a} {endResult}{" "}
                      {diccionario.de} {totalSize} {diccionario.resultados}
                    </div>
                  ) : (
                    // Display a message when there are no matches
                    <div className="data-info" style={{ fontWeight: "bold" }}>
                      {diccionario.sinresultados}
                    </div>
                  )}
                  <PaginationListStandalone {...paginationProps} />
                </div>
              </div>
            );
          }}
        </PaginationProvider>
        <ModalComponent
          top={"40%"}
          alturaCustom={"50%"}
          tituloModal={tituloEnvioAvisos}
          cuerpoModal={
            <FormularioEnvioAvisos
              comunidadesSeleccionadas={comunidadesSeleccionadas}
              abrirDiagolo={abrirDiagolo}
              cerrarDiagolo={() => setModalOpen(false)}
            />
          }
          isModalOpen={isModalOpen}
          setModalOpen={setModalOpen}
          closeEnvios={true}
        />
        <ModalComponent
          planHistorico={planHistorico}
          setPlanHistorico={setPlanHistorico}
          step={step}
          setStep={setStep}
          alturaCustom={step < 4 ? "45%" : "600px"}
          anchuraCustom={"85%"}
          tituloModal={diccionario.ProcesoAltaComunidad}
          alturaContenido={step === 4 ? "500px" : ""}
          cuerpoModal={
            <Wizard
              Comunidad={Identificador}
              step={step}
              setStep={setStep}
              plan={plan}
              setPlan={setPlan}
              resetFormContrato={resetFormContrato}
              refrescar={refrescar}
              setRefrescar={setRefrescar}
              datosCompletosComunidad={datosCompletosSeleccionados}
              planHistorico={planHistorico}
              esModificar={esModificar}
              setEsModificar={setEsModificar}
              isModalOpen={isModalOpenAlta}
              setModalOpen={setModalOpenAlta}
            />
          }
          isModalOpen={isModalOpenAlta}
          setModalOpen={setModalOpenAlta}
        />
        <ModalComponent
          tituloModal={diccionario.ProcesoAltaComunidad}
          anchuraCustom={"40%"}
          alturaCustom={"30%"}
          cuerpoModal={
            <div>
              <p>{diccionario.IntroduceCodigoGratiws}</p>
              <div className="codigo-gratis">
                <TextField
                  className="mt-3"
                  value={codigoAlta}
                  name="codigoAlta"
                  onChange={(e) => setCodigoAlta(e.target.value)}
                  onKeyDown={handleKeyPress2}
                />
                <button
                  onClick={() => comprobarComuBaja()}
                  className="btn btn-outline-primary mt-3 px-4"
                  disabled={codigoAlta === ""}
                >
                  {diccionario.aceptar}
                </button>
              </div>
            </div>
          }
          isModalOpen={modalOpenDemo}
          setModalOpen={setModalOpenDemo}
          closeEnvios={true}
        />
        <ModalComponent
          setStep={setStep}
          tituloModal={diccionario.ProcesoAltaComunidad}
          anchuraCustom={"65%"}
          alturaCustom={"40%"}
          cuerpoModal={
            <StepContratado
              planHistorico={planHistorico}
              bajaFuncion={darDeBaja}
              modificarFuncion={handleModificarC365}
              plan={plan}
            />
          }
          isModalOpen={modalOpenContratado}
          setModalOpen={setModalOpenContratado}
        />
      </div>

      {FormularioEnvioAvisos}
    </div>
  );
};

export default ComunidadesTabla;
